export const types = {
    TEXT: 'TEXT',
    BUTTONSCOPE: 'BUTTON-SCOPE',
    BUTTONITEM: 'BUTTON-ITEM',
    LISTSCOPE: 'LIST-SCOPE',
    LISTITEM: 'LIST-ITEM',
    SENDMEDIA: 'SEND-MEDIA',
    DYNAMICLIST: 'DYNAMIC-LIST'
};
